import { itemsService } from '../service'

export default (from, size,keyword='', optDates='', fromDate='', toDate='', status='', hasMatches='') => {
	return new Promise(resolve => {
		itemsService.itemsInvestigacion(from, size,keyword, optDates, fromDate, toDate, status, hasMatches)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
